import styled from 'styled-components';
import {StyledButton} from '../Buttons/DefaultButton/DefaultButton.styles';

export const Container = styled.div`
  display: flex;
  flex-direction: column;

  .skills {
    color: #000;
    font-size: 1.25rem;
    font-weight: 600;
    line-height: 1.5rem;
    letter-spacing: 0.15px;
    text-align: left;
    margin: 1rem 0 0.75rem 0;

    @media (max-width: 465px) {
      font-size: 1.125rem;
      line-height: 1.375rem;
      margin: 0.75rem 0 0.5rem 0;
    }
  }

  .error-text {
    color: var(--error-main, #FB7672);
    font-size: 0.875rem;
    margin-bottom: 0.25rem;

    @media (max-width: 465px) {
      font-size: 0.8125rem;
      margin-bottom: 0.125rem;
    }
  }
  
  /* Additional languages below the grid */
  > .labelContainer {
    margin: 0;
    padding: 0.25rem 0;
    
    @media (max-width: 465px) {
      padding: 0.125rem 0;
    }
  }
`;

export const SectionTitle = styled.div`
  color: #000;
  font-size: 1.25rem;
  font-weight: 600;
  line-height: 1.5rem;
  letter-spacing: 0.15px;
  text-align: left;
  margin: 0.75rem 0 0.5rem 0;

  @media (max-width: 465px) {
    font-size: 1.125rem;
    line-height: 1.375rem;
    margin: 0.5rem 0 0.375rem 0;
  }
`;

export const CommonLanguagesGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 0.25rem 0.5rem;
  margin-bottom: 0.5rem;

  @media (max-width: 465px) {
    grid-template-columns: 1fr 1fr;
    gap: 0.125rem 0.5rem;
    margin-bottom: 0.375rem;
  }

  .labelContainer {
    margin: 0;
    padding: 0.25rem 0;
    border: none;
    border-radius: 0;
    background-color: transparent;
    transition: none;

    @media (max-width: 465px) {
      padding: 0.125rem 0;
    }

    &:hover {
      border-color: transparent;
      background-color: transparent;
    }

    .MuiFormControlLabel-label {
      width: 100%;
      font-size: 1rem;
      
      @media (max-width: 465px) {
        font-size: 0.9375rem;
      }
    }
  }
`;

export const DropdownContainer = styled.div`
  grid-column: 2; /* Position in 2nd column of 4th row (8th position) */
  margin: 0;
  max-width: none;

  @media (max-width: 465px) {
    grid-column: 2; /* Keep in 2nd column on mobile too */
    margin: 0;
  }

  .MuiFormControl-root {
    width: 100%;
  }

  .MuiInputLabel-outlined {
    color: var(--text-secondary, #666);
    font-size: 0.9375rem;
    
    @media (max-width: 465px) {
      font-size: 0.875rem;
    }
  }

  .MuiOutlinedInput-root {
    border-radius: 6px;
    font-size: 0.9375rem;
    
    @media (max-width: 465px) {
      border-radius: 4px;
      font-size: 0.875rem;
    }
    
    &:hover .MuiOutlinedInput-notchedOutline {
      border-color: var(--primary-blue, #0B4598);
    }

    &.Mui-focused .MuiOutlinedInput-notchedOutline {
      border-color: var(--primary-blue, #0B4598);
    }
  }
`;

export const AddLanguageButton = styled(StyledButton)`
  max-width: 30rem !important;
  margin: 1rem auto 0 !important;
`; 